import './Input.css';

const Input = function Input(
    { label = '', placeholder = '', type = 'text', name, value, onChange, autoFocus },
) {
    const handleOnWheel = (e) => {
        e.target.blur();
        e.stopPropagation();
    };

    const handleKeyDown = (e) => {

        const excludedChars = ["e", "E", "+", "-"];
        if (type === "number" && name === "input1") {
            if (!excludedChars.includes(".")) {
                excludedChars.push(".");
            }
        }
        if (type === "number") {
            if (excludedChars.includes(e.key)) {
                e.preventDefault();
            }
        }
    };

    const handlePaste = (e) => {
        if (type === "number") {
            const pasted = e.clipboardData.getData("text");
            if (/[eE+-]/.test(pasted)) {
                e.preventDefault();
            }
        }
    };

    return (
        <div className='flex flex-col input-container'>
            <label htmlFor={name} className='input-label'>{label}</label>
            <div className="input-prefix-wrapper items-center">
                {(name === "input2" && value > 0) && <span className="prefix">$</span>}

                <input
                    name={name}
                    min={0}
                    className={`form-input ${name === "input2" && value > 0 && "input2"}`}
                    type={type}
                    inputMode={type === "number" ? "numeric" : "url"}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    onWheel={handleOnWheel}
                    onKeyDown={handleKeyDown}
                    onPaste={handlePaste}
                    draggable={false}
                    autoFocus={autoFocus}
                />
            </div>
        </div>
    );
};

export default Input;
